import { useState, useContext } from 'react';
import { Formik } from 'formik';
import { DatePicker, FilterModal, SelectSearch } from 'components';
import { DateConvert } from 'utilities';
import { DropdownContext } from '../context/DropdownContext';

export const ModalFilterPage = ({ toggle, data, setData }) => {
  const [loading, setLoading] = useState(false);
  const { dropdownSubkon, dropdownVendor } = useContext(DropdownContext);
  const option = { label: 'Semua Data', value: undefined };
  const optionsubkon = [option].concat(dropdownSubkon?.data ?? []);
  const optionVendor = [option].concat(dropdownVendor?.data ?? []);

  const formInitialValues = {
    tgl_transfer_work_order_subkon_mulai: data.tgl_transfer_work_order_subkon_mulai,
    tgl_transfer_work_order_subkon_selesai:
      data.tgl_transfer_work_order_subkon_selesai,

    tgl_permintaan_work_order_subkon_mulai:
      data.tgl_permintaan_work_order_subkon_mulai,
    tgl_permintaan_work_order_subkon_selesai:
      data.tgl_permintaan_work_order_subkon_selesai,

    id_item_subkon: data.id_item_subkon,
    id_vendor: data.id_vendor,
  };
  const formSubmitHandler = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    setData({
      ...data,
      ...values,
      active: checkActive,
      page: 1,
    });

    toggle();
  };

  const onResetButtonClick = (setValues) => {
    setLoading(true);

    const myPromise = new Promise((resolve) => {
      setValues({
        tgl_transfer_work_order_subkon_mulai: undefined,
        tgl_transfer_work_order_subkon_selesai: undefined,
        tgl_permintaan_work_order_subkon_mulai: undefined,
        tgl_permintaan_work_order_subkon_selesai: undefined,
        id_item_subkon: undefined,
        id_vendor: undefined,
      });

      setTimeout(() => resolve(), 300);
    });

    myPromise.then(() => setLoading(false));
  };

  const onTanggalChange = (
    dates,
    values,
    setValues,
    value_mulai,
    value_selesai,
  ) => {
    const [start, end] = dates;
    const startDate = start ? DateConvert(start).default : null;
    const endDate = end ? DateConvert(end).default : null;

    setValues({
      ...values,
      [value_mulai]: startDate,
      [value_selesai]: endDate,
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={formInitialValues}
      onSubmit={formSubmitHandler}
    >
      {({ values, handleSubmit, setFieldValue, setValues }) => (
        <FilterModal
          isToggle
          toggleModal={toggle}
          onResetButtonClick={() => onResetButtonClick(setValues)}
          onFilterButtonClick={handleSubmit}
        >
          <DatePicker
            selectsRange
            monthsShown={2}
            label="Tgl. Transfer Subkon Work Order"
            placeholderText="Pilih Tanggal Transfer Subkon Work Order"
            startDate={
              values?.tgl_transfer_work_order_subkon_mulai
                ? new Date(values?.tgl_transfer_work_order_subkon_mulai)
                : ''
            }
            endDate={
              values?.tgl_transfer_work_order_subkon_selesai
                ? new Date(values?.tgl_transfer_work_order_subkon_selesai)
                : ''
            }
            onChange={(dates) =>
              onTanggalChange(
                dates,
                values,
                setValues,
                'tgl_transfer_work_order_subkon_mulai',
                'tgl_transfer_work_order_subkon_selesai',
              )
            }
          />

          <DatePicker
            selectsRange
            label="Tgl. Permintaan Work Order"
            placeholderText="Pilih Tanggal Permintaan Produksi"
            startDate={
              values?.tgl_permintaan_work_order_subkon_mulai
                ? new Date(values?.tgl_permintaan_work_order_subkon_mulai)
                : ''
            }
            endDate={
              values?.tgl_permintaan_work_order_subkon_selesai
                ? new Date(values?.tgl_permintaan_work_order_subkon_selesai)
                : ''
            }
            onChange={(dates) =>
              onTanggalChange(
                dates,
                values,
                setValues,
                'tgl_permintaan_work_order_subkon_mulai',
                'tgl_permintaan_work_order_subkon_selesai',
              )
            }
            monthsShown={2}
          />

          <SelectSearch
            key="1"
            label="Item Subkon"
            placeholder="Pilih Item subkon"
            defaultValue={optionsubkon?.find(
              (val) => val.value === values.id_item_subkon,
            )}
            option={optionsubkon}
            onChange={(val) => setFieldValue('id_item_subkon', val.value)}
            loading={dropdownSubkon?.isLoading || loading}
          />

          <SelectSearch
            key="2"
            label="Vendor"
            placeholder="Pilih Vendor"
            defaultValue={optionVendor?.find(
              (val) => val.value === values.id_vendor,
            )}
            option={optionVendor}
            onChange={(val) => setFieldValue('id_vendor', val.value)}
            loading={dropdownSubkon?.isLoading || loading}
          />
        </FilterModal>
      )}
    </Formik>
  );
};
